import InventoryTransferTable from "./InventoryTransferTable";
export default InventoryTransferTable;
